/**
 * TypeORM ValueTransformer for decimal/numeric columns.
 *
 * PostgreSQL returns decimal/numeric values as strings to avoid
 * floating-point precision loss. This transformer converts them
 * back to numbers on read, preventing silent string concatenation
 * bugs (e.g. "10.50" + "5.25" = "10.505.25").
 *
 * Known limitation: JavaScript Number has ~15-17 significant digits.
 * Columns with precision > 15 (e.g. DECIMAL(20,10)) may lose trailing
 * digits. For those cases, keep values as strings and use a decimal
 * library for arithmetic.
 *
 * Usage: @Column({ type: 'decimal', transformer: numericTransformer })
 */
export const numericTransformer = {
  to(value: number | null | undefined): number | null | undefined {
    return value;
  },
  from(value: string | number | null | undefined): number | null {
    if (value === null || value === undefined) return null;
    if (typeof value === 'number') return value;
    const trimmed = value.trim();
    const parsed = Number(trimmed);
    if (isNaN(parsed) || !isFinite(parsed)) {
      console.error(`[numericTransformer] Invalid decimal value: "${value}". Returning null.`);
      return null;
    }
    return parsed;
  },
};
